import { TRUST_POINTS, IMAGES } from "../../lib/site-data";
import { Check } from "lucide-react";

export default function WhyUs() {
    return (
        <section className="relative py-24 md:py-32 border-b border-white/5 overflow-hidden" data-testid="whyus-section">
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid lg:grid-cols-12 gap-12 items-center">
                    <div className="lg:col-span-5 relative">
                        <div className="relative rounded-2xl overflow-hidden border border-white/5">
                            <img
                                src={IMAGES.clinicInterior}
                                alt="Klinik ortam"
                                className="w-full h-[480px] object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-tr from-black/60 via-transparent to-transparent"></div>
                            <div className="absolute bottom-6 left-6 right-6">
                                <p className="text-[10px] uppercase tracking-[0.3em] text-cyan-300/80 mb-2">
                                    Klinik Ortam
                                </p>
                                <p className="font-display text-xl text-white">
                                    Sterilizasyon ve hijyen önceliği
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-7 space-y-8">
                        <div>
                            <p className="text-xs uppercase tracking-[0.3em] text-cyan-300/80 mb-3">
                                Neden Biz?
                            </p>
                            <h2 className="font-display text-3xl md:text-5xl text-white tracking-tight text-balance">
                                Şeffaf süreç, kişisel değerlendirme
                            </h2>
                        </div>

                        <div className="grid sm:grid-cols-2 gap-4">
                            {TRUST_POINTS.map((p) => (
                                <div
                                    key={p.title}
                                    className="bg-[#0E0E0E] border border-white/5 rounded-xl p-5 hover:border-cyan-400/30 transition-colors"
                                    data-testid={`trust-${p.title}`}
                                >
                                    <div className="flex items-start gap-3">
                                        <div className="w-7 h-7 rounded-md bg-cyan-400/10 border border-cyan-400/30 flex items-center justify-center flex-shrink-0">
                                            <Check
                                                className="h-3.5 w-3.5 text-cyan-300"
                                                strokeWidth={2.5}
                                            />
                                        </div>
                                        <div>
                                            <h3 className="font-display text-base text-white mb-1">
                                                {p.title}
                                            </h3>
                                            <p className="text-xs text-zinc-400 leading-relaxed">
                                                {p.text}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
